// extracted by mini-css-extract-plugin
export default {"your_rd":"FB","title":"GB","subtitle":"HB","rd_bio_wrapper":"IB","rd_text_mobile":"JB","rd_bio":"KB","img":"LB","rd_info":"MB","rd_name":"NB","rd_stat":"OB","rd_text":"PB","btn_mobile":"QB"};
    if(module.hot) {
      // 1726593106140
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  